// First Created - 17 Aug 2026
// Author - Atul Pandey
// Purpose - RTK Query API slice for Coach cohort challenge evaluation reporting
// Updated - 19 Aug 2026 - added PowerPoint and PDF report downloads

import {
    apiSlice,
} from '@/app/api/apiSlice'


/*
|--------------------------------------------------------------------------
| Shared Query Parameter Builder
|--------------------------------------------------------------------------
*/

// 01 - Build Coach evaluation report query parameters.
const buildCoachEvaluationReportParams = ({
    orgId,
    trailId,
    sessionId,
    cohortId,
    coachId,
    challengeId,
    evaluationNumber,
}) => {

    const params =
        new URLSearchParams({
            orgId,
            trailId,
            sessionId,
            cohortId,
            coachId,
            challengeId,
        })


    if (
        evaluationNumber !== undefined &&
        evaluationNumber !== null
    ) {
        params.set(
            'evaluationNumber',
            evaluationNumber
        )
    }


    return params
}


export const coachEvaluationReportsApiSlice =
    apiSlice.injectEndpoints({
        endpoints:
            builder => ({

                /*
                |--------------------------------------------------------------------------
                | Get Coach Cohort Challenge Evaluation Report
                |--------------------------------------------------------------------------
                |
                | evaluationNumber is optional.
                |
                | Supplied:
                |     one exact evaluation cycle across the cohort.
                |
                | Omitted:
                |     complete multi evaluation journey.
                |
                */

                getCoachEvaluationReport:
                    builder.query({
                        query:
                            ({
                                orgId,
                                trailId,
                                sessionId,
                                cohortId,
                                coachId,
                                challengeId,
                                evaluationNumber,
                            }) => {

                                const params =
                                    buildCoachEvaluationReportParams({
                                        orgId,
                                        trailId,
                                        sessionId,
                                        cohortId,
                                        coachId,
                                        challengeId,
                                        evaluationNumber,
                                    })


                                return {
                                    url:
                                        `/reports/coachEvaluations?${params.toString()}`,

                                    method:
                                        'GET',
                                }
                            },

                        keepUnusedDataFor:
                            60,
                    }),


                /*
                |--------------------------------------------------------------------------
                | Download Coach Evaluation PowerPoint
                |--------------------------------------------------------------------------
                */

                downloadCoachEvaluationPowerPoint:
                    builder.mutation({
                        query:
                            ({
                                orgId,
                                trailId,
                                sessionId,
                                cohortId,
                                coachId,
                                challengeId,
                                evaluationNumber,
                            }) => {

                                const params =
                                    buildCoachEvaluationReportParams({
                                        orgId,
                                        trailId,
                                        sessionId,
                                        cohortId,
                                        coachId,
                                        challengeId,
                                        evaluationNumber,
                                    })


                                return {
                                    url:
                                        `/reports/coachEvaluations/powerpoint?${params.toString()}`,

                                    method:
                                        'GET',

                                    responseHandler:
                                        response =>
                                            response.blob(),
                                }
                            },
                    }),


                /*
                |--------------------------------------------------------------------------
                | Download Coach Evaluation PDF
                |--------------------------------------------------------------------------
                */

                downloadCoachEvaluationPdf:
                    builder.mutation({
                        query:
                            ({
                                orgId,
                                trailId,
                                sessionId,
                                cohortId,
                                coachId,
                                challengeId,
                                evaluationNumber,
                            }) => {

                                const params =
                                    buildCoachEvaluationReportParams({
                                        orgId,
                                        trailId,
                                        sessionId,
                                        cohortId,
                                        coachId,
                                        challengeId,
                                        evaluationNumber,
                                    })


                                return {
                                    url:
                                        `/reports/coachEvaluations/pdf?${params.toString()}`,

                                    method:
                                        'GET',

                                    responseHandler:
                                        response =>
                                            response.blob(),
                                }
                            },
                    }),
            }),
    })


export const {
    useGetCoachEvaluationReportQuery,

    useDownloadCoachEvaluationPowerPointMutation,
    useDownloadCoachEvaluationPdfMutation,
} =
    coachEvaluationReportsApiSlice